import React from 'react';
import style from './Solicitar.module.css';

const Solicitar = ({ t }) => {
  const url = t('Products.Smartsen.Request.url');

  return (
    <div className={style.servicios}>
      <div className={style.divText}>
        <p className={style.text1}>
          {t('Products.Smartsen.Request.text')}
        </p>

        <p className={style.text2}>
          {t('Products.Smartsen.Request.text2')}
        </p>
      </div>

      <div className={style.divButton}>
        <a
          className={style.link}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className={style.contacto}>
            {t('Products.Smartsen.Request.text3')}
          </div>
        </a>
      </div>
    </div>
  );
};

export default Solicitar;
